"use client";

import React, { useState, useEffect } from "react";
import Link from "next/link";
import { FaChevronLeft } from "react-icons/fa";

export default function NewsPreview({ isDark }) {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const res = await fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL}news/list`);
        if (res.ok) {
          const data = await res.json();
          // Filter active news
          const activeNews = data.filter((item) => item.is_active);
          // Reverse to show latest first
          setNews(activeNews.reverse());
        }
      } catch (error) {
        console.error("Failed to fetch news", error);
      } finally {
        setLoading(false);
      }
    };
    fetchNews();
  }, []);

  if (loading) return <div className="text-center py-20 text-gray-400 font-light">در حال بارگذاری بلاگ...</div>;

  return (
    <section dir="rtl" className={`w-full max-w-[1700px] mx-auto px-6 md:px-12 lg:px-16 py-4 md:py-8 transition-colors duration-[1200ms] ease-in-out ${isDark ? "bg-[#050505] text-white" : "bg-white text-gray-900"}`}>
      {/* Title & Link to /news */}
      <div className="flex justify-start items-center mb-6 md:mb-8">
        <Link
          href="/news"
          className={`text-base md:text-lg font-extralight flex items-center gap-2 group transition-colors duration-[1200ms] ${isDark ? "text-gray-300 hover:text-white" : "text-gray-400 hover:text-blue-950"}`}
        >
          <span>بلاگ</span>
          <FaChevronLeft className={`text-xs group-hover:-translate-x-1 transition-transform transition-colors duration-[1200ms] ${isDark ? "text-gray-300" : "text-gray-400"}`} />
        </Link>
      </div>

      {/* Grid: 3 columns on Desktop/Tablet, 1 column on Mobile */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-14">
        {news.slice(0, 3).map((item) => (
          <Link
            key={item.id}
            href={`/news/${item.id}`}
            className={`group relative w-full aspect-[900/630] sm:aspect-[486/320] rounded-[60px] md:rounded-[40px] overflow-hidden block transition-all duration-500 ${isDark ? "bg-[#050505]" : "bg-white"
              }`}
          >
            {/* Cover Image */}
            <img
              src={item.home_image || item.image || "/placeholder.jpg"}
              alt={item.title}
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 border-0 outline-none select-none"
            />

            {/* Dark Linear 80% Gradient Overlay matching ProductSlider */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent transition-opacity duration-300 group-hover:from-black/90 group-hover:via-black/35" />

            {/* Text & Icon at bottom right matching ProductSlider */}
            <div className="absolute bottom-6 right-6 left-6 flex items-center justify-between text-white z-10">
              <span className="text-base sm:text-lg md:text-xl font-extralight tracking-normal group-hover:text-gray-200 transition-colors line-clamp-1">
                {item.title}
              </span>
              <FaChevronLeft className="text-xs text-gray-300 shrink-0 group-hover:-translate-x-1 transition-transform duration-300" />
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}